
import { useState } from 'react';

import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import Button from 'src/onboarding/components/ui/button/Button';

import { Title } from 'src/onboarding/components/typography/Title/Title';
import { MultiCheck } from 'src/onboarding/components/ui/multi-check/MultiCheck';
import { MultiOption } from 'src/onboarding/components/ui/multi-check/Option';

import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const rewards = useStore((state) => state.rewards);
  const setRewards = useStore((state) => state.setRewards);
  const [next, setNext] = useState(rewards.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setRewards(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.rewards.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={rewards} onChange={handleChange}>
          <MultiOption value={'Buy new clothes'}>
            <span>👗</span> {t('onboarding.rewards.options.buy')}
          </MultiOption>
          <MultiOption value={'Take a trip'}>
            <span>✈️</span> {t('onboarding.rewards.options.take')}
          </MultiOption>
          <MultiOption value={'Spend a day at the spa'}>
            <span>💆</span> {t('onboarding.rewards.options.spend')}
          </MultiOption>
          <MultiOption value={'Celebrate with friends'}>
            <span>🎉</span> {t('onboarding.rewards.options.celebrate')}
          </MultiOption>
          <MultiOption value={'Other'}>
            <span>✨</span> {t('onboarding.rewards.options.other')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.rewards.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'rewards',
              answer: rewards.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
